module.exports = __webpack_public_path__ + "static/media/diners.fb078e9b.png";